import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@mui/material'

const DataTable = ({ data }) => {
  return (
    <TableContainer component={Paper}>
      {/* <Typography variant="h6" component="div" style={{ padding: '16px' }}>
        Datos de Palabras Procesadas
      </Typography> */}
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>
              <strong>Debug</strong>
            </TableCell>
            <TableCell>
              <strong>Parent</strong>
            </TableCell>
            <TableCell>
              <strong>Children</strong>
            </TableCell>
            <TableCell>
              <strong>Caption</strong>
            </TableCell>
            <TableCell>
              <strong>Outcome</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Word Type</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Type</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Tense</strong>
            </TableCell>
            <TableCell align="right">
              <strong>Source</strong>
            </TableCell>
            <TableCell align="right">
              <strong>uuid</strong>
            </TableCell>
            <TableCell>
              <strong>ImageURL</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {row.debug}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.parent}
              </TableCell>
              <TableCell component="th" scope="row">
                <span
                  dangerouslySetInnerHTML={{
                    __html: row.children.join('<br /> --------- <br />'),
                  }}
                />
              </TableCell>
              <TableCell component="th" scope="row">
                {row.caption}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.outcome}
              </TableCell>
              <TableCell align="right">{row.wordType || '-'}</TableCell>
              <TableCell align="right">
                {[...new Set(row.pictos.map(({ type }) => type))].join(', ') ||
                  '-'}
              </TableCell>
              <TableCell align="right">{row.tense || '-'}</TableCell>
              <TableCell align="right">{row.source || '-'}</TableCell>
              <TableCell component="th" scope="row">
                {row.uuid}
              </TableCell>
              <TableCell component="th" scope="row">
                {row.imageUrl}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default DataTable
